// Hàm thuần cho biểu đồ SVG tự viết của trang Studio (SPEC Studio mục 8.8): trục bắt đầu từ 0, 4 vạch lưới,
// mốc làm tròn bằng niceMax. Không dùng thư viện biểu đồ.

import { colors } from 'theme/tokens';

/** Số vạch lưới ngang (không kể đường 0). */
export const GRID_LINES = 4;

/** Hệ số "đẹp" của bước lưới (× 10^k): đủ dày để cột cao nhất chiếm phần lớn khung. */
const NICE_FACTORS = [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];

/** Bước "đẹp" nhỏ nhất ≥ `raw` (tối thiểu 1 vì số KC là số nguyên). */
export function niceStep(raw: number): number {
  if (!(raw > 0) || !Number.isFinite(raw)) return 1;
  const exp = Math.floor(Math.log10(raw));
  const base = Math.pow(10, exp);
  const f = raw / base;
  const nice = NICE_FACTORS.find((n) => f <= n + 1e-9) ?? 10;
  return Math.max(1, nice * base);
}

/** Mốc trên cùng của trục: bội của bước đẹp, luôn ≥ `max`, chia đều `lines` vạch. */
export function niceMax(max: number, lines: number = GRID_LINES): number {
  if (!(max > 0) || !Number.isFinite(max)) return lines;
  return niceStep(max / lines) * lines;
}

/** Các mốc từ 0 tới `top` (gồm cả hai đầu): lines + 1 giá trị. */
export function ticks(top: number, lines: number = GRID_LINES): number[] {
  const step = top / lines;
  const out: number[] = [];
  for (let i = 0; i <= lines; i += 1) out.push(Math.round(step * i * 100) / 100);
  return out;
}

/** Đổi giá trị sang độ dài pixel trên trục [0, top] → [0, size]; kẹp trong khoảng. */
export function scale(value: number, top: number, size: number): number {
  if (!(top > 0)) return 0;
  return Math.max(0, Math.min(size, (value / top) * size));
}

/** Cắt chữ dài cho nhãn SVG (chữ đầy đủ đặt trong <title>). */
export function truncate(text: string, maxChars: number): string {
  if (!text || text.length <= maxChars) return text || '';
  return `${text.slice(0, Math.max(1, maxChars - 1))}…`;
}

/**
 * Màu cột theo vai trò (mục 8.9): tháng gốc `accent`; tháng so sánh 1, 2, 3 lần lượt `lilac`, `peach`, `sun`
 * (dải Hoàng hôn — chỉ để tô, không làm màu chữ).
 */
export const BAR_COLORS = {
  base: colors.accent,
  compare: [colors.lilac, colors.peach, colors.sun],
  empty: colors.surfaceMuted,
  emptyLine: colors.line,
  grid: colors.line,
  axis: colors.textSecondary,
  value: colors.heading,
  estimateInk: colors.warningInk,
  upInk: colors.successInk,
  upSoft: colors.successSoft,
  downInk: colors.dangerInk,
  downSoft: colors.dangerSoft,
};

export function compareColor(index: number): string {
  const list = BAR_COLORS.compare;
  return list[((index % list.length) + list.length) % list.length];
}

// Mã id duy nhất cho <pattern>/<title> của từng biểu đồ (React 18 có useId nhưng @types/react 17 chưa có).
let chartSeq = 0;
export function nextChartId(prefix: string): string {
  chartSeq += 1;
  return `${prefix}-${chartSeq}`;
}
